import req from 'shared/req';

export function dismissDeadlineModal(studentId) {
  return () => {
    const url = `/v1/users/${studentId}/feature-interactions/transfer-education-deadline-modal`;
    const date = new Date();
    return req({
      url,
      method: 'put',
      data: {featureData: {dismissed: true, timestamp: date}},
    });
  };
}
